import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import { t } from "i18next";

export const useServiceProviderReviewTabMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemReviewInfo */
  const menuItemReviewInfo = {
    id: "service-provider-reviewInfo",
    title: t("AppModuleNames.SuperAdmin.reviewInfo"),
    url: baseRouteMaker(routes.SERVICE_PROVIDER_REVIEW_INFO),
  };
  tempMenuGroup.push(menuItemReviewInfo);
  /* menuItemReviewInfo */

  return tempMenuGroup;
};
